module.exports = __webpack_public_path__ + "img/icon-32-ic-warning-oval.22b3e5a9.svg";